import * as z from "@-/com.npmjs.zod";
import { morphemeGraphemeMorphemeSliceSchema } from "#morpheme-grapheme-morpheme-slice-schema";
import { graphemeStrokeListSchema } from "#grapheme-stroke-slice";

/** Minimum data to render and verify the front of a card. */
export const drillMorphemeSliceSchema = z.object({
  /** Needed to render the grapheme in font mode */
  graphemes: z.array(morphemeGraphemeMorphemeSliceSchema).optional(),

  /** Stroke geometry for handwriting verification */
  graphemeStrokes: graphemeStrokeListSchema,

  /** Needed to verify the user's response */
  back: z.string().optional(),

  /** Needed for verifying the user's pinyin response */
  pinyinList: z.array(
    z.object({
      gloss: z.string().optional(),
      pinyin: z.string(),
    }),
  ),
});

export type DrillMorphemeSlice = z.infer<typeof drillMorphemeSliceSchema>;
